import React, { FC } from 'react';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { RelayFragment } from 'src/shared/types';
import { useProductConfigurationState } from '../state';
import { productTemplate_listItem$data } from '../state/queries/__generated__/productTemplate_listItem.graphql';
import TemplateCatalogPaginationFragment from './templateCatalogPaginationFragment';
import { templateCatalogListQuery } from './__generated__/templateCatalogListQuery.graphql';

const TemplateCatalogListQuery: FC<{
    search: string;
    categoryID: number | null;
    onProductClick: (providerProduct: Omit<RelayFragment<productTemplate_listItem$data>, ' $fragmentType'>) => void;
}> = ({ search, categoryID, onProductClick }) => {
    const { state } = useProductConfigurationState();

    //const category = selectedCategory ? (selectedCategory.indexOf('c_') === 0 ? selectedCategory.substring(2) : null) : null;
    //const macroCategory = selectedCategory ? (selectedCategory.indexOf('m_') === 0 ? selectedCategory.substring(2) : null) : null;

    const query = useLazyLoadQuery<templateCatalogListQuery>(
        graphql`
            query templateCatalogListQuery($categoryID: Long) {
                ...templateCatalogPaginationFragment__productTemplates @arguments(categoryID: $categoryID)
            }
        `,
        {
            categoryID
        }
    );

    return <TemplateCatalogPaginationFragment query={query} search={search} categoryID={categoryID} onProductClick={onProductClick} />;
};

export default TemplateCatalogListQuery;
